module.exports = __webpack_public_path__ + "img/daichao1.21b1a156.png";